import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import noImage from '../../assets/img/no-image.jpg'
import { lineWobble } from "ldrs";

lineWobble.register()

const LazyImage = ({ src, index }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [isLoading, setIsLoading] = useState(true);  

  const handleImageLoad = () => {
    setIsLoading(false); 
  };

  const handleImageError = (e) => {
    e.target.src = noImage;
    setIsLoading(false);
  };

  return (
    <div ref={ref} key={index}>
      {inView && (
        <div className="relative w-full aspect-[4/3] max-h-[400px]">
          {isLoading && (
            <div className="w-full h-full absolute inset-0 bg-black/50 opacity-40 z-10" />
          )}
          {isLoading && (
            <div className="absolute z-20 w-full h-full flex justify-center items-center">
              <l-line-wobble
                size="70"
                stroke="3"
                speed="1.75" 
                color="#fff" 
              />
            </div>
          )}  
          <img
            src={src}
            alt={`slide-${index}`}
            onLoad={handleImageLoad} 
            onError={handleImageError} 
            className="w-full aspect-[4/3] object-cover max-h-[400px] transition-opacity duration-300 ease-in-out"
          />
        </div>
      )}
    </div>
  );
};

export default LazyImage;